<template>
  <div class="rent-wrap">
    <!-- 收費方案:線上下訂已移除,此處為參考收費;實際洽詢走「詢問場地」 -->
    <div class="sub-title">收費方案</div>
    <div class="mb-[10px] text-[14px] text-osn-grey-01">以下為參考收費,實際可預約時段與報價以場地主回覆為準。</div>
    <!-- 詢問制:方案僅供參考,改直式清單(去水平捲動與「可選取」假象) -->
    <div class="flex flex-col">
      <div v-for="(rent, index) in sortedRentGroups" :key="index"
        class="py-[12px] border-b border-osn-grey-03 last:border-b-0">
        <div class="flex items-center justify-between mb-[4px]">
          <span class="text-[18px] font-bold text-osn-dark-grey-00 mr-[8px]">{{ rent.group }}</span>
          <span class="flex items-center font-bold text-osn-dark-grey-00 whitespace-nowrap">
            <span v-if="rent.is_on_sale"
              class="mr-[6px] rounded-[2px] bg-osn-yellow-00 text-osn-grey-00 py-[2px] px-[4px] text-[12px]">優惠</span>
            <span class="text-[16px]">NT$ {{ projectFromPrice(rent) }}</span>
            <span class="ml-1 text-[12px] font-normal">起</span>
          </span>
        </div>
        <div class="flex flex-wrap mb-[4px]">
          <div v-for="item in Object.entries(rent.rent_types)" :key="item[0]"
            class="bg-osn-grey-03 py-[2px] px-[6px] text-[12px] text-osn-grey-00 rounded-[2px] mr-[4px] mb-[2px]">
            {{ parseRentType(item[0]) }}
          </div>
        </div>
        <div class="flex items-start justify-between">
          <span class="flex-1 mr-[8px] text-[14px] leading-[18px] text-osn-grey-01 line-clamp-2">{{ rent.description
            }}</span>
          <span class="shrink-0 text-[14px] text-osn-blue-00 cursor-pointer whitespace-nowrap"
            @click="handleProject(rent, $event)">詳情 ›</span>
        </div>
      </div>
    </div>

    <!-- [移除付費功能] 註解掉選擇日期、時間及預訂相關區塊
    <div class="flex items-baseline">
      <div class="sub-title">選擇日期、時間</div>
      <el-tooltip effect="light">
        <div class="flex items-center text-[18px] ml-[20px] text-osn-blue-00">
          <el-icon class="mr-2">
            <InfoFilled />
          </el-icon>
          {{ '開放時間' }}
        </div>
        <template #content>
          <div v-if="selectedRentGroup && selectedRent" v-for="day in Object.entries(selectedRent.week_days)"
            class="text-[14px] mb-[4px]">
            {{ getWeekDay(day) }}
          </div>
          <div v-if="selectedRentGroup && selectedRent && selectedRent.holiday.length > 0" class="text-[14px] mb-[4px]">
            {{ getHoliday(selectedRent.holiday) }}
          </div>
        </template>
      </el-tooltip>
    </div>
    <ConfirmationRequirementText :need-be-confirm="needBeConfirmModel" :hint-model="false">
    </ConfirmationRequirementText>
    <div v-if="selectedRentGroup" class="tab-wrap mt-[20px]">
      <div v-for="(item, index) in sortedRentTypes" :key="item[0]" class="tab point"
        :class="{ 'tab-active': index === rentSelectedIndex }" @click="rentSelectedIndexChange(index)">
        {{ chooseRentGroup.group }}
      </div>
    </div>

    <div class="max-w-[682px] mx-auto">
      <div :key="selectedKey">
        <SpaceRentHourLayout v-if="
          selectedRentGroup &&
          Object.entries(selectedRentGroup.rent_types)[
            rentSelectedIndex
          ][0].toString() === '0'
        " :key="'SpaceRentHourLayout' + 0" :advance-booking-days="advanceBookingDaysModelValue" :space-rent="Object.entries(selectedRentGroup.rent_types)[rentSelectedIndex][1]
            " :space-usage-status="usageStatusModelValue" @onTimeSelected="onTimeSelected"
          :space-id="spaceIdModelValue" />
        <SpaceRentDayLayout v-if="
          selectedRentGroup &&
          Object.entries(selectedRentGroup.rent_types)[
            rentSelectedIndex
          ][0].toString() === '1'
        " :key="'SpaceRentDayLayout' + 1" :advance-booking-days="advanceBookingDaysModelValue" :space-rent="Object.entries(selectedRentGroup.rent_types)[rentSelectedIndex][1]
            " :space-usage-status="usageStatusModelValue" @onTimeSelected="onTimeSelected" />
        <SpaceRentPeriodLayout v-if="
          selectedRentGroup &&
          Object.entries(selectedRentGroup.rent_types)[
            rentSelectedIndex
          ][0].toString() === '4'
        " :key="'SpaceRentPeriodLayout' + 4" :advance-booking-days="advanceBookingDaysModelValue" :space-rent="Object.entries(selectedRentGroup.rent_types)[rentSelectedIndex][1]
          " :space-usage-status="usageStatusModelValue" @onTimeSelected="onTimeSelected" :space-id="spaceIdModelValue" />
      </div>

      <div v-if="timeSelectedObj.isOK" class="price-wrap">
        <div class="flex justify-between">
          <div>{{ priceString }}</div>
          <div :class="{ 'discount-total': oriAmount > amount && false }">
            {{
              `＝NT$${parseNumber(
                estimatedAmount -
                accessoriesModelValue
                  .filter((a) => a.selected)
                  .reduce((prev, curr) => prev + curr.price, 0)
              )}`
            }}
          </div>
        </div>
      </div>

      <div v-if="accessoriesArray.length > 0" class="accessories-wrap">
        <div class="title">{{ $t("space.accessories_title") }}</div>
        <div v-for="(accessory, index) in accessoriesArray" class="accessory-wrap">
          <div class="item">
            <div class="check-box point" :class="{ 'check-box-active': accessory.selected }"
              @click="handleAccessoryClick(accessory)" />
            <div class="content-wrap">
              <div class="content-info">
                <div class="name">{{ accessory.name }}</div>
                <div class="name price">
                  {{ `NT$${parseNumber(accessory.price)}` }}
                </div>
              </div>
              <div class="desc-wrap point" @click="accessory.ellipsis = !accessory.ellipsis">
                <div class="desc" :class="{ 'text-ellipsis': accessory.ellipsis }">
                  {{ accessory.description }}
                </div>
                <img class="w-[20px]" :class="{ 'img-expand': !accessory.ellipsis }"
                  src="@/assets/image/icon/space/ic_expand_more.svg" alt="" />
              </div>
            </div>
          </div>
          <div v-if="index < accessoriesArray.length - 1" class="accessories-divider"></div>
        </div>
        <div v-if="accessoriesModelValue.length > 3" class="point" @click="accessoriesExpand = !accessoriesExpand">
          <div class="accessories-divider"></div>
          <div class="accessories-expand">
            <span>
              {{
                accessoriesExpand
                  ? $t("space.accessories_collapse")
                  : $t("space.accessories_expand")
              }}
            </span>
            <img :class="{ 'img-expand': accessoriesExpand }" src="@/assets/image/icon/space/ic_expand_more.svg"
              alt="" />
          </div>
        </div>
        <div class="total-wrap">
          <div>{{ $t("reserve.total") }}</div>
          <div>{{ `＝NT$${parseNumber(estimatedAmount)}` }}</div>
        </div>
      </div>

      <div v-if="
        isDateInRange(
          timeSelectedObj.begin_time,
          newYearRange[0],
          newYearRange[1]
        ) ||
        isDateInRange(
          timeSelectedObj.end_time,
          newYearRange[0],
          newYearRange[1]
        )
      " class="book-btn point book-btn-line" @click="openLine">
        過年期間請洽 Line
      </div>

      <div v-else class="flex mt-[16px] items-center justify-around">
        <div class="book-btn point" :class="{
          'book-btn-active': timeSelectedObj.isOK && canReservationModelValue,
          'book-btn-line': !canReservationModelValue,
        }" @click="goReservation">
          <div>{{ bookingButtonText }}</div>
        </div>
        <div @click="openLine" class="underline text-[18px] cursor-pointer">專人預訂
        </div>
      </div>

    </div>
    -->


    <!--    方案介紹彈窗-->
    <el-dialog v-model="dialogProjectVisible" :show-close="false" center align-center custom-class="w-fit p-0">
      <div
        class="relative w-[455px] mobile:w-[355px] h-fit min-h-[146px] border-[2px] rounded-[20px] cursor-pointer px-[24px] pt-[16px] pb-[24px] text-osn-dark-grey-00 border-cg-yellow bg-white">
        <svg-icon v-if="dialogProject.is_on_sale" name="is_on_sale" size="90"
          class="absolute top-[-3px] right-[-2px] z-[0]" />
        <div class="relative flex items-center justify-between mb-[6px] mr-[54px] z-[1]">
          <span class="text-[18px] font-bold truncate">{{
            dialogProject.group
          }}</span>
        </div>
        <div class="flex mb-[6px]">
          <div v-for="item in Object.entries(dialogProject.rent_types)"
            class="bg-osn-grey-03 py-[2px] px-[6px] text-[12px] text-osn-grey-00 rounded-[2px] mr-[4px]">
            <span>{{ parseRentType(item[0]) }}</span>
          </div>
        </div>
        <div class="w-full min-h-[34px] mb-[10px]">
          <span class="text-[15px] leading-[1.5em] text-osn-grey-00 cursor-pointer whitespace-pre-line">
            {{ dialogProject.description }}
          </span>
        </div>
        <div class="flex items-center justify-end font-bold">
          <div class="mr-[6px] rounded-[2px] bg-osn-yellow-00 text-osn-grey-00 py-[2px] px-[4px] text-[12px]"
            v-if="dialogProject.is_on_sale">
            優惠
          </div>
          <span class="text-osn-dark-grey-00 text-[16px]">
            {{
              "NT$ " +
              parseNumber(
                Math.min(
                  ...Object.values(
                    getProjectCheapestPrices(dialogProject)
                  ).filter((price) => price !== null)
                )
              )
            }}
          </span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script setup lang="ts">
import { parseNumber, parseRentType, parseRentUnit } from "~/utils/parseTool";
import SpaceRentDayLayout from "~/components/SpaceDetail/SpaceRentDayLayout.vue";
import SpaceRentHourLayout from "~/components/SpaceDetail/SpaceRentHourLayout.vue";
import SpaceRentPeriodLayout from "~/components/SpaceDetail/SpaceRentPeriodLayout.vue";
import ConfirmationRequirementText from "@/components/SpaceDetail/ConfirmationRequirementText.vue";
import { computed, nextTick, reactive, ref } from "vue";
import { getPriceSSR, type GetPriceRequest } from "~/api";
import { useReservationStore } from "@/stores/reservation";
import type { SpaceOpeningTime } from "~/utils/types";
import { spaceLinkToWebsite } from "@/config/common";
import { getProjectCheapestPrices } from "~/utils/newPriceTool";
import { useSettingStore } from "@/stores/setting";
import { useI18n } from "#imports";
import { InfoFilled } from "@element-plus/icons-vue";
import { useBehaviorFlow } from "~/composables/useBehaviorFlow";

// BI-UI v2:portal_availability(docs/behavior-insights/portal-merchant-ui/implementation.md §5)。
// 「plan」step:租客查看收費方案詳情,與 SpaceCalendar.vue 的 date/slot 同一個 feature。
const FEATURE_ID = "portal_availability";
const behaviorFlow = useBehaviorFlow();

interface TimeSlot {
  start: string;
  end: string;
  price: string;
  shortest_rental_duration: number;
}

interface WeekDays {
  [key: string]: TimeSlot[]; // 0-6 代表周日到周六
}

interface RentType {
  week_days: WeekDays;
  holiday: TimeSlot[];
  dates: Record<string, TimeSlot[]>;
}

interface RentGroup {
  group: string;
  description: string;
  rent_types: {
    [key: string]: RentType; // '0' 代表按小时, '1' 代表按天等
  };
  is_on_sale: boolean;
}

interface SpaceRent {
  rent_groups: RentGroup[];
  booking_price_ratio: string;
}

const { t } = useI18n();
const settingStore = useSettingStore()
const clientLineUrl = import.meta.env.VITE_APP_BASE_CLIENT_LINE_URL;
const lineUrl = import.meta.env.VITE_APP_BASE_LINE_URL
const router = useRouter();
const route = useRoute();
const { $fbq } = useNuxtApp();
const reservationStore = useReservationStore();
const newYearRange = ["2025/01/24", "2025/02/03"];


const spaceIdModelValue = defineModel("spaceId", { type: Number, default: -1 });
const spaceOpeningTimesModelValue = defineModel<SpaceOpeningTime[]>(
  "spaceOpeningTimes",
  { type: Array, default: [] }
);
// const spaceRentModelValue = defineModel('spaceRent', {type: Array, default: () => []})
const spaceRentModelValue = defineModel<SpaceRent>("spaceRent", {
  type: Object,
  default: () => ({
    rent_groups: [],
    booking_price_ratio: "",
  }),
});
const shortestRentalModelValue = defineModel("shortestRentalDuration", {
  type: Number,
  default: -1,
});
const advanceBookingDaysModelValue = defineModel("advanceBookingDays", {
  type: Number,
  default: -1,
});
const usageStatusModelValue = defineModel("spaceUsageStatus", {
  type: Array,
  default: () => [],
});
const accessoriesModelValue = defineModel("spaceAccessories", {
  type: Array,
  default: () => [],
});
const canReservationModelValue = defineModel("canReservation", {
  type: Boolean,
  default: false,
});
const spaceInfoObjModelValue = defineModel("spaceInfoObj", {
  type: Object,
  default: () => ({}),
});

const selectedRentGroup = defineModel("selectedRentGroup", {
  type: Object,
  default: null,
});
const rentSelectedIndex = defineModel("rentSelectedIndex", {
  type: Number,
  default: 0,
});
let selectedKey = 0;
const needBeConfirmModel = defineModel('needBeConfirm', { type: Boolean, default: true })

const amount = ref<number>(0);
const estimatedAmount = ref<number>(0);
const oriAmount = ref<number>(0);
const selectedPeriodPrice = ref<number>(0);

const timeSelectedObj = reactive({
  isOK: false,
  rent_type: -1,
  begin_time: "",
  end_time: "",
});
const accessoriesExpand = ref<Boolean>(false);

const chooseRentGroup = computed(() => {
  return spaceRentModelValue.value.rent_groups.find(
    (group) => group.group === selectedRentGroup.value.group
  );
});

const bookingButtonText = computed(() => {
  if (!canReservationModelValue.value) {
    return t("booking_not_yet")
  }
  if (!timeSelectedObj.isOK) {
    return t("please_select_date_time")
  }
  return t("booking_right_now")
})


const accessoriesArray = computed(() => {
  if (accessoriesExpand.value) {
    return accessoriesModelValue.value;
  } else {
    return accessoriesModelValue.value.slice(0, 3);
  }
});

const sortedRentTypes = computed(() => {
  const order = ["0", "4", "1"]; // 期望的排序順序
  return Object.entries(selectedRentGroup.value.rent_types).sort((a, b) => {
    return order.indexOf(a[0]) - order.indexOf(b[0]);
  });
});

const sortedRentGroups = computed(() => {
  if (!spaceRentModelValue.value?.rent_groups) return [];

  // 創建一個新的陣列，避免修改原始的陣列並排序
  return [...spaceRentModelValue.value.rent_groups].sort((a, b) => {
    // 首先按is_on_sale排序
    if (a.is_on_sale && !b.is_on_sale) return -1;
    if (!a.is_on_sale && b.is_on_sale) return 1;

    // 如果is_on_sale相同，则按是否有rent_types[0]排序
    const aHasHourly = "0" in a.rent_types;
    const bHasHourly = "0" in b.rent_types;

    if (aHasHourly && !bHasHourly) return -1;
    if (!aHasHourly && bHasHourly) return 1;

    return 0;
  });
});

const priceString = computed(() => {
  if (spaceRentModelValue.value) {
    const rentType = Object.entries(selectedRentGroup.value.rent_types)[
      rentSelectedIndex.value
    ][0];
    const unit = parseRentUnit(rentType);
    const startDate = new Date(timeSelectedObj.begin_time);
    const endDate = new Date(timeSelectedObj.end_time);

    switch (Number(rentType)) {
      case 0:
        const hourDifference = (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60);
        // oriAmount.value = rent.price * hourDifference
        return `NT$${parseNumber(
          (estimatedAmount.value / hourDifference).toFixed(1)
        )} X ${hourDifference}${unit}`;

      case 1:
        const dayDifference = Math.ceil(
          (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24)
        );
        // oriAmount.value = rent.price * dayDifference
        return `NT$${parseNumber(
          (estimatedAmount.value / dayDifference).toFixed(1)
        )} X ${dayDifference}${unit}`;

      case 4:
        // oriAmount.value = selectedPeriodPrice.value
        return `${timeSelectedObj.begin_time.slice(
          11,
          16
        )}~${timeSelectedObj.end_time.slice(11, 16)}`;
    }
  } else {
    return "";
  }
});

const selectedAccessoryIds = computed(() =>
  accessoriesModelValue.value
    .filter((a) => a.selected)
    .map((a) => a.accessory_id)
);

onMounted(() => {
  accessoriesModelValue.value.forEach((a) => {
    a.selected = false;
    a.ellipsis = true;
  });
  handleSelectedRentGroup(spaceRentModelValue.value.rent_groups[0]);
});

function handleSelectedRentGroup(rent) {
  if (selectedRentGroup.value === rent) {
    return;
  }
  selectedRentGroup.value = rent;
  rentSelectedIndexChange(0);

  /// 調整好預選日期時間，會觸發 onTimeSelected，就會呼叫 handlePrice
  // nextTick(() => {
  //   if (timeSelectedObj.isOK) {
  //     handlePrice(selectedPeriodPrice.value)
  //   }
  // })
}

async function handlePrice(periodPrice?: number) {
  // 為了不要等 api 回來的時間差，畫面會跳一下才更新價格，所以先給一個最大值
  // amount.value = 999999

  /// 24:00:00 轉 23:59:59
  let end_time = timeSelectedObj.end_time;
  if (end_time.endsWith("24:00:00")) {
    end_time = end_time.substring(0, 10) + " 23:59:59";
  }

  try {
    const res = await getPriceSSR(
      spaceIdModelValue.value,
      timeSelectedObj.rent_type,
      timeSelectedObj.begin_time,
      end_time,
      selectedAccessoryIds.value,
      selectedRentGroup.value.group
    );
    amount.value = res.amount;
    estimatedAmount.value = res.estimated_amount;
  } catch (error) {
    console.log(error);
  }
}

function onTimeSelected(
  isOK: boolean,
  rent_type: number,
  begin_time: string,
  end_time: string,
  periodPrice: number = 0
) {
  timeSelectedObj.isOK = isOK;
  timeSelectedObj.rent_type = rent_type;
  timeSelectedObj.begin_time = begin_time;
  timeSelectedObj.end_time = end_time;

  if (isOK) {
    selectedPeriodPrice.value = periodPrice;
    handlePrice(periodPrice);
  }
}

function isDateInRange(
  date: string,
  startDate: string,
  endDate: string
): boolean {
  // 將輸入的日期轉換為 Date 物件
  const targetDate = new Date(date);
  const start = new Date(startDate);
  const end = new Date(endDate);

  // 比較日期範圍
  return targetDate >= start && targetDate <= end;
}

function openLine() {
  window.open(lineUrl);
}

function goReservation() {
  // line://ti/p/@994ecjfo?oat_referrer=PROFILE

  if (!canReservationModelValue.value) {
    openLine();
    return;
  }
  if (spaceIdModelValue?.value && spaceLinkToWebsite[spaceIdModelValue.value]) {
    window.open(spaceLinkToWebsite[spaceIdModelValue.value]);
    return;
  }

  if (
    canReservationModelValue.value &&
    timeSelectedObj &&
    timeSelectedObj.isOK
  ) {
    reservationStore.updateReservationInfo(spaceInfoObjModelValue.value);
    reservationStore.updateAmounts(amount.value);
    reservationStore.updateRentType(timeSelectedObj.rent_type);
    reservationStore.updateRentBeginTime(timeSelectedObj.begin_time);
    reservationStore.updateRentEndTime(timeSelectedObj.end_time);
    reservationStore.updateAccessories(
      accessoriesModelValue.value.filter((a) => a.selected)
    );
    reservationStore.updateEstimatedAmount(estimatedAmount.value);
    reservationStore.updateRentGroup(selectedRentGroup.value.group);
    reservationStore.updateNeedBeConfirm(needBeConfirmModel.value);

    $fbq("trackCustom", "OSAddToCart", { value: estimatedAmount.value });
    router.push({ path: "/reserve", query: route.query });
  }
}

function handleAccessoryClick(accessory) {
  accessory.selected = !accessory.selected;
  if (timeSelectedObj.isOK) {
    handlePrice(selectedPeriodPrice.value);
  }
}

function rentSelectedIndexChange(index: number) {
  rentSelectedIndex.value = index;
  reSetPrice();
  /// 重新 render 時租、日租、時段租 選單
  selectedKey = (selectedKey + 1) % 10;
}

function reSetPrice() {
  amount.value = 0;
  estimatedAmount.value = 0;
  oriAmount.value = 0;
}

const dialogProjectVisible = ref(false);
const dialogProject = ref(null);

function handleProject(rent, event) {
  event.stopPropagation();
  dialogProject.value = rent;
  dialogProjectVisible.value = true;
  behaviorFlow.startTask(FEATURE_ID, "plan", "read");
  behaviorFlow.trackStep(FEATURE_ID, "plan", "attempt");
}

// 方案最低起價(整數),供直式清單顯示「NT$ X 起」
function projectFromPrice(rent) {
  const prices = Object.values(getProjectCheapestPrices(rent)).filter((p) => p !== null);
  return parseNumber(Math.min(...prices));
}

const selectedRent = computed(() => {
  return selectedRentGroup.value?.rent_types[Object.entries(selectedRentGroup.value.rent_types)[rentSelectedIndex.value][0]]
})

function getWeekDay(day) {
  const days = ["日", "一", "二", "三", "四", "五", "六"];
  let time = '';
  day[1].forEach((item) => {
    if (time.length > 0) {
      time += '、';
    }
    time += `${item.start}~${item.end}`;
  })
  return `週${days[day[0]]} ${time}`;
}

function getHoliday(holiday) {
  let time = '';
  holiday.forEach((item) => {
    if (time.length > 0) {
      time += '、';
    }
    time += `${item.start}~${item.end}`;
  })
  return `假日 ${time}`;
}
</script>
<style scoped lang="scss">
:deep(.el-dialog) {
  @apply w-[500px] mobile:w-[400px];
  background: transparent;
  box-shadow: none;
}

.rent-wrap {
  @apply mt-[20px];

  .tab-wrap {
    @apply flex mx-[-20px];

    .tab {
      @apply w-full text-center text-[15px] text-osn-dark-grey-00 pb-[4px];
      border-bottom: 3px solid #e1e0e0;
      padding: 6px 0 3px;
    }

    .tab-active {
      @apply font-bold;
      border-bottom: 3px solid #ffd66b;
      background: #ffd66b;
      border-radius: 4px;
    }
  }

  .price-wrap {
    @apply text-[18px] text-osn-dark-grey-00;

    .discount-total {
      @apply text-osn-grey-01;
      text-decoration-line: line-through;
    }

    .discount-wrap {
      @apply flex items-baseline justify-end;

      div:first-child {
        @apply text-[14px] text-osn-grey-01 mr-[6px];
      }

      div:nth-child(2) {
        @apply text-[18px] text-osn-dark-grey-00;
      }
    }
  }

  .accessories-wrap {
    @apply mt-[20px] bg-[#FFF4DF] mx-[-20px] px-[20px];

    .title {
      @apply text-osn-grey-01 text-[14px] font-bold pt-[16px];
    }

    .accessory-wrap {
      .item {
        @apply flex mt-[12px];

        .check-box {
          @apply w-[24px] h-[24px] mr-[8px];
          background-image: url(@/assets/image/icon/space/ic_check_box.svg);
        }

        .check-box-active {
          background-image: url(@/assets/image/icon/space/ic_check_box_active.svg);
        }

        .content-wrap {
          @apply w-full;

          .content-info {
            @apply flex justify-between;

            .name {
              @apply text-[16px] text-osn-dark-grey-00;
            }

            .price {
              @apply font-bold;
            }
          }

          .desc-wrap {
            @apply flex justify-between items-start mb-[15px];

            .desc {
              @apply w-full break-words text-osn-grey-01 text-[14px];
            }

            .text-ellipsis {
              display: -webkit-box;
              -webkit-box-orient: vertical;
              overflow: hidden;
              -webkit-line-clamp: 1;
              /* 行数 */
              word-break: break-all;
            }
          }
        }
      }
    }

    .accessories-divider {
      @apply w-full h-[1px] border-b border-[#B1B1B1];
    }

    .img-expand {
      transform: rotate(180deg);
    }

    .accessories-expand {
      @apply h-[38px] flex justify-center items-center text-[14px];
      color: var(--osn-grey-00, #4a4a4a);

      span {
        @apply mr-[4px];
      }

      img {
        @apply w-[20px];
      }
    }

    .total-wrap {
      @apply flex justify-between mx-[-20px] pt-[16px] px-[20px] bg-white text-[18px] font-bold text-osn-dark-grey-00;
    }
  }

  .book-btn {
    @apply flex items-center justify-center w-2/3 h-[50px] text-[18px] rounded-[50px] font-bold text-osn-grey-01 bg-osn-grey-03;
  }

  .book-btn-active {
    @apply text-osn-dark-grey-00 bg-osn-yellow-00;
  }

  .book-btn-line {
    @apply text-osn-white-00 bg-osn-green-4;
  }
}
</style>
